import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { connect } from 'react-redux';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { numberFormat, numberWithCommas, validNumberCheck, replaceCommas, findArrayObjectIndex } from '../../../utils/utils';
import * as logger from '../../../logger';
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import { Form } from 'react-final-form';
import { YourDetailsSideBarCss } from './InvoiceSideBarCss';
import TextInputState from '../Inputs/TextInputState';
import SyncIcon from '@material-ui/icons/Sync';
import { getUserDetails, accountDetails } from '../../../store/actions/authActionCreators';
import { GetValuesFromGst, updateChatView } from "../../../store/actions/userActionCreators";
import { getAllLocationsForProfile,getAllLocationsForStates } from '../../../store/actions/homeActionCreator';
import {
    Grid,
    IconButton,
    Button
} from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { trackDwebEvent } from '../../analytics';
import { getMilliDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils';
import { editInvoice } from '../../../store/actions/tripActionCreator';


const filter = createFilterOptions({
    limit: 30
});
const YourDetailsSideBar = ({
    open,
    onClose,
    onConfirm,
    dispatchFetchUserDetails,
    sideBarName,
    user,
    trip,
    dispatchGetDetailsFromGst,
    dispatchChatView,
    dispatchGetAllLocationsForProfile,
    dispatchEditInvoice
}) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [gstNumberValue, setGstNumberValue] = useState("");
    const [spinMotion, setSpinMotion] = useState(false);
    const [companyNameValue, setCompanyNameValue] = useState("");
    const [addressLine1Value, setAddressLine1Value] = useState("");
    const [addressLine2Value, setAddressLine2Value] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [pincodeValue, setPincodeValue] = useState("");
    const [emailAddressValue, setEmailAddressValue] = useState("");
    const [mobileNumberValue, setMobileNumberValue] = useState("");
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [displayFillGstInfo, setDisplayFillGstInfo] = useState(true);
    const [invoiceIdValue, setInvoiceIdValue] = useState("");


    const classes = YourDetailsSideBarCss();

    const initialValues = {
        gstNumber: gstNumberValue,
        companyName: companyNameValue,
        addressLine1: addressLine1Value,
        addressLine2: addressLine2Value,
        stateName: stateValue,
        pincode: pincodeValue,
        emailAddress: emailAddressValue,
        mobileNumber: (mobileNumberValue.replace(/(\d{5})(\d{5})/, "$1-$2")).trim()
    }

    useEffect(() => {

        const yourDetails = trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.userGSTDetails ? trip.singleInvoiceInfo.userGSTDetails : "";

        dispatchChatView(false);
        dispatchGetAllLocationsForProfile(
            () => {

                logger.log("Your Details Side Bar Dweb", "------> Get all locations Success ");
                setAddressLine1Value(yourDetails && yourDetails.addressLine1 ? yourDetails.addressLine1 : "");
                setAddressLine2Value(yourDetails && yourDetails.addressLine2 ? yourDetails.addressLine2 : "");
                setCompanyNameValue(yourDetails && yourDetails.companyName ? yourDetails.companyName : "");
                setPincodeValue(yourDetails && yourDetails.pincode ? yourDetails.pincode : "");
                setStateValue(yourDetails && yourDetails.state ? yourDetails.state : "");
                setGstNumberValue(yourDetails && yourDetails.gstNumber ? yourDetails.gstNumber : "");
                setEmailAddressValue(yourDetails && yourDetails.email ? yourDetails.email : "");
                setMobileNumberValue(yourDetails && yourDetails.contactNumber ? yourDetails.contactNumber : "");
                setInvoiceIdValue(trip.singleInvoiceInfo.invoiceDetails && trip.singleInvoiceInfo.invoiceDetails.id ? trip.singleInvoiceInfo.invoiceDetails.id : "");

            },
            () => {
                logger.log("Your Details Side Bar Dweb", "------> Get all locations Failure");
            }
        )

    }, [open, trip.singleInvoiceInfo])

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    const onSubmit = async values => {

        let companyNameArray = values && values.companyName ? values.companyName.split(" ") : [];
        let companyNameCapitalize = [];

        if (companyNameArray && companyNameArray.length > 0) {
            companyNameArray.forEach((value) => {
                if (value) {
                    companyNameCapitalize.push((value.charAt(0).toUpperCase()) + value.slice(1));
                }
            })
        }

        var data = {
            userGSTDetails: {
                gstNumber: values && values.gstNumber ? (values.gstNumber).toUpperCase() : "",
                companyName: companyNameCapitalize && companyNameCapitalize.length > 0 ? (companyNameCapitalize.join(" ")).trim() : "",
                addressLine1: values.addressLine1 ? values.addressLine1 : "",
                addressLine2: values.addressLine2 ? values.addressLine2 : "",
                pincode: values.pincode ? values.pincode : "",
                email: values.emailAddress ? values.emailAddress : "",
                state: values.stateName ? values.stateName : "",
                contactNumber: values.mobileNumber ? (values.mobileNumber).replace("-", "") : ""
            }
        }

        dispatchEditInvoice(invoiceIdValue, 
            data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setDialogOpen(false);
                    onConfirm();
                    logger.log("Your Details Side Bar Dweb", "Edit user successfull");

                    if (data.response) {
                        const invoiceInfo = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {};
                        trackDwebEvent('Dweb Invoice edit Party info changed', {
                            party_name: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerName ? invoiceInfo.invoiceDetails.customerName : "",
                            party_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerId ? invoiceInfo.invoiceDetails.customerId : "",
                            count_of_trips: invoiceInfo && invoiceInfo.trips && invoiceInfo.trips.length ? invoiceInfo.trips.length : 0,
                            total_invoice_amount: invoiceInfo && invoiceInfo.amounts && invoiceInfo.amounts.total ? invoiceInfo.amounts.total : "",
                            invoice_number: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceNumber ? invoiceInfo.invoiceDetails.invoiceNumber : "",
                            invoice_date: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(invoiceInfo.invoiceDetails.invoiceDate) : "",
                            due_days: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.dueIn ? invoiceInfo.invoiceDetails.dueIn : 0,
                            invoice_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.id ? invoiceInfo.invoiceDetails.id : "",
                            party_company_name: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.companyName ? invoiceInfo.customerGSTDetails.companyName : "",
                            party_gst_number: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.gstNumber ? invoiceInfo.customerGSTDetails.gstNumber : "",
                            user_company_name: values && values.companyName ? values.companyName : "",
                            user_gst_number: values && values.gstNumber ? values.gstNumber : "",
                            gst_percentage: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.gstPercentage ? invoiceInfo.otherDetails.gstPercentage : "",
                            terms_and_conditions: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.termsAndConditions ? invoiceInfo.otherDetails.termsAndConditions : "",
                            signature_url: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.signatureLink ? invoiceInfo.otherDetails.signatureLink : ""
                        })
                    }

                }
            },
            () => {
                logger.log("Your Details Side Bar Dweb", "Edit user failed");
            }
        );

    }

    const validate = values => {

        const errors = {};

        let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));
        let gstValidation = config && config.gstRegex ? new RegExp(config.gstRegex) : "";
        let companyNameValue = values.companyName ? /^[A-Za-z]+$/.test(values.companyName.replace(/\s+/g, '')) : "";
        let mobileNumber = values.mobileNumber ? /^[1-9]{1}[0-9]{9}$/.test(values.mobileNumber.replace("-", "")) : "";
        let emailValidation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let pinCodeValidation = values.pincode ? /^[0-9]{6}$/.test(values.pincode) : "";

        let gstUpperCase = values.gstNumber ? (values.gstNumber).toUpperCase() : "";

        if (values.gstNumber && (!gstValidation.test(gstUpperCase))) {
            errors.gstNumber = "Please enter Valid GST Number"
            setDisplayFillGstInfo(false);
        } else {
            setDisplayFillGstInfo(true);
        }

        if (!companyNameValue || !values.companyName) {
            errors.companyName = "Please enter valid company name."
        }

        if (values.mobileNumber && !mobileNumber) {
            errors.mobileNumber = "Please enter valid 10-digit mobile number."
        }

        if (values.emailAddress && !emailValidation.test(String(values.emailAddress).toLowerCase())) {
            errors.emailAddress = "Please enter valid email."
        }

        if (values.pincode && !pinCodeValidation) {
            errors.pincode = "Please enter valid 6-digit pincode."
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;

    }

    const handleGstInfo = () => {
        setSpinMotion(true);
        const gstNumberValueUppercase = gstNumberValue ? gstNumberValue.toUpperCase() : "";
        setTimeout(() => {
            if (gstNumberValueUppercase.length == 15 && displayFillGstInfo) {
                dispatchGetDetailsFromGst(gstNumberValueUppercase,
                    (data) => {
                        if (data && data.status && data.status.code == 200) {
                            logger.log("Your Details Side Bar Dweb", "Get Details from GST Successfull");

                            // Assigning variable values from GST Info.
                            if (data.response) {

                                setAddressLine1Value(data.response.address_line_1 ? data.response.address_line_1 : "");
                                setAddressLine2Value(data.response.address_line_2 ? data.response.address_line_2 : "");
                                setCompanyNameValue(data.response.name ? data.response.name : "");
                                setPincodeValue(data.response.pincode ? data.response.pincode : "");
                                setStateValue(data.response.state ? data.response.state : "");

                            }

                            setTimeout(() => {
                                setSpinMotion(false);
                            }, 700)
                        }
                    },
                    () => {
                        logger.log("Your Details Side Bar Dweb", "Get Details from GST Failed");
                    }
                );
            }
        }, 400);
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <>
                        <div className={classes.titleV1}>GST Number</div>
                        <TextInputState
                            placeholder="Enter GST Number"
                            name="gstNumber"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setGstNumberValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV2 }}
                        />
                        {values && values.gstNumber && values.gstNumber.length == 15 && displayFillGstInfo &&
                            <div className={classes.divAlign} onClick={() => handleGstInfo()}>
                                <SyncIcon className={spinMotion ? "sync-icon" : classes.syncIcon} />
                                <div className={classes.textV1}>Fill Company Information from GST Number</div>
                            </div>
                        }
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Company Name*</div>
                        <TextInputState
                            placeholder="Enter Company Name"
                            name="companyName"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setCompanyNameValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Address Line 1</div>
                        <TextInputState
                            placeholder="Enter Address Line"
                            name="addressLine1"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setAddressLine1Value(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Address Line 2</div>
                        <TextInputState
                            placeholder="Enter Address Line"
                            name="addressLine2"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setAddressLine2Value(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.divAlignV1}>
                        <div className={classes.widthV1}>
                            <div className={classes.titleV1}>State</div>
                            {user && user.stateName && user.stateName.length > 0 &&
                                <Autocomplete
                                    classes={{
                                        listbox: classes.listBoxAutoCompelete,
                                        option: classes.listBoxOption,
                                        endAdornment: classes.displayEndAdornment,
                                        inputRoot: classes.autoCompleteInput
                                    }}
                                    id="select-state-name-list"
                                    name="stateName"
                                    size="small"
                                    value={stateValue}
                                    placeholder="State"
                                    onChange={(event, newValue) => {
                                        setStateValue(newValue)
                                    }}
                                    options={user && user.stateName ? user.stateName : []}
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    getOptionValue={option => option}
                                    getOptionLabel={(option) => {
                                        // e.g value selected with enter, right from the input
                                        return option ? option : '';
                                    }}
                                    getOptionSelected={(option, value) => option === value}
                                    disableCloseOnSelect={false}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                        return filtered;

                                    }}
                                    renderOption={(option, params) => {
                                        return (
                                            <div className={classes.divV1}>
                                                <LocationOnIcon className={classes.colorV1} />
                                                <div className={classes.divV2}>
                                                    {option}
                                                </div>
                                            </div>
                                        );

                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            // label="Enter Reason"
                                            placeholder="State"
                                            variant="outlined"
                                            name="stateName"
                                            style={{ margin: 0, marginTop: 6 }}
                                        />
                                    )}
                                    multiple={false}
                                />
                            }
                        </div>

                        <div className={classes.widthV2}>
                            <div className={classes.titleV1}>Pincode</div>
                            <TextInputState
                                placeholder="Pincode"
                                name="pincode"
                                variant="outlined"
                                size="small"
                                onChange={(e) => { setPincodeValue(e.target.value) }}
                                className={classes.mtV2}
                                classes={{ root: classes.textFieldV1 }}
                            />
                        </div>
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Email Address</div>
                        <TextInputState
                            placeholder="Enter Email Address"
                            name="emailAddress"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setEmailAddressValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
            {
                size: 12,
                visible: true,
                inline: false,
                field: (
                    <div className={classes.mtV1}>
                        <div className={classes.titleV1}>Mobile</div>
                        <TextInputState
                            placeholder="Enter Mobile Number"
                            name="mobileNumber"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setMobileNumberValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            },
        ]
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>
                        Your Details
                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit; return (
                                <form onSubmit={handleSubmit} noValidate>
                                    <Grid container alignItems="flex-start" spacing={0}>
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >

                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Cancel
                    </Button>
                    <Button variant="contained" className={classes.saveButton} classes={{ disabled: classes.saveButtonDisabled }} disabled={confirmDisabled}
                        onClick={event => submit(event)}
                    >
                        Save
                    </Button>

                </SideBarDialogActions>

            </Drawer>
        </>
    )
}

const YourDetailsSideBarWithRouter = withRouter(YourDetailsSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchFetchUserDetails: (onSuccess, onFailure) => {
        dispatch(getUserDetails(onSuccess, onFailure))
    },
    dispatchGetDetailsFromGst: (gstNumber, onSuccess, onFailure) => { dispatch(GetValuesFromGst(gstNumber, onSuccess, onFailure)) },
    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchGetAllLocationsForProfile: (onSuccess, onFailure) => { dispatch(getAllLocationsForStates(onSuccess, onFailure)) },
    dispatchEditInvoice: (invoiceId, invoiceData, onSuccess, onFailure) => {
        dispatch(editInvoice(invoiceId, invoiceData, onSuccess, onFailure))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(YourDetailsSideBarWithRouter)